// Helper Excel untuk Master Payroll HO (import / export / template).
// HO TIDAK memakai kolom Shift / BPJS (beda dari SO).
import * as XLSX from "xlsx-js-style";

export const PAYROLL_HO_COLS = {
  Nik: "Nik",
  NamaKaryawan: "Nama Karyawan",
  UpahPokok: "Upah Pokok",
  Keahlian: "Keahlian",
  JkIN: "Jam Kerja IN",
  JkOUT: "Jam Kerja OUT",
  THarian: "Tunjangan Harian",
  TLemburMakan: "Tunjangan Makan",
  Harikeenam: "Hari Keenam",
};

const HEADER_ORDER = [
  PAYROLL_HO_COLS.Nik,
  PAYROLL_HO_COLS.NamaKaryawan,
  PAYROLL_HO_COLS.UpahPokok,
  PAYROLL_HO_COLS.Keahlian,
  PAYROLL_HO_COLS.JkIN,
  PAYROLL_HO_COLS.JkOUT,
  PAYROLL_HO_COLS.THarian,
  PAYROLL_HO_COLS.TLemburMakan,
  PAYROLL_HO_COLS.Harikeenam,
];

const COL_WIDTHS = [16, 26, 14, 12, 13, 13, 16, 15, 14];

export const toNum = (v) => {
  if (v === null || v === undefined || v === "") return 0;
  const n = parseFloat(String(v).replace(/[^0-9.\-]/g, ""));
  return isNaN(n) ? 0 : n;
};

function styleSheet(ws) {
  ws["!cols"] = COL_WIDTHS.map((w) => ({ wch: w }));
  const range = XLSX.utils.decode_range(ws["!ref"]);
  for (let c = range.s.c; c <= range.e.c; c++) {
    const addr = XLSX.utils.encode_cell({ r: 0, c });
    if (!ws[addr]) continue;
    ws[addr].s = {
      font: { bold: true, color: { rgb: "FFFFFF" } },
      fill: { fgColor: { rgb: "2F5597" } },
      alignment: { horizontal: "center", vertical: "center" },
    };
  }
  return ws;
}

function rowFromRecord(r) {
  return {
    [PAYROLL_HO_COLS.Nik]: r.Nik ?? "",
    [PAYROLL_HO_COLS.NamaKaryawan]: r.NamaKaryawan ?? "",
    [PAYROLL_HO_COLS.UpahPokok]: r.UpahPokok ?? 0,
    [PAYROLL_HO_COLS.Keahlian]: r.Keahlian ?? 0,
    [PAYROLL_HO_COLS.JkIN]: r.JkIN ?? "",
    [PAYROLL_HO_COLS.JkOUT]: r.JkOUT ?? "",
    [PAYROLL_HO_COLS.THarian]: r.THarian ?? 0,
    [PAYROLL_HO_COLS.TLemburMakan]: r.TLemburMakan ?? 0,
    [PAYROLL_HO_COLS.Harikeenam]: r.Harikeenam ?? "",
  };
}

export function exportPayrollHOExcel(records) {
  const rows = (records || []).map(rowFromRecord);
  const ws = XLSX.utils.json_to_sheet(rows, { header: HEADER_ORDER });
  styleSheet(ws);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Master Payroll HO");
  const ts = new Date().toISOString().slice(0, 19).replace(/[:T]/g, "-");
  XLSX.writeFile(wb, `Master_Payroll_HO_${ts}.xlsx`);
}

export function downloadPayrollHOTemplate() {
  const example = {
    [PAYROLL_HO_COLS.Nik]: "HO-20250107",
    [PAYROLL_HO_COLS.NamaKaryawan]: "(informasi saja - diabaikan saat import)",
    [PAYROLL_HO_COLS.UpahPokok]: 5000000,
    [PAYROLL_HO_COLS.Keahlian]: 0,
    [PAYROLL_HO_COLS.JkIN]: "08:00",
    [PAYROLL_HO_COLS.JkOUT]: "17:00",
    [PAYROLL_HO_COLS.THarian]: 0,
    [PAYROLL_HO_COLS.TLemburMakan]: 20000,
    [PAYROLL_HO_COLS.Harikeenam]: "Saturday",
  };
  const ws = XLSX.utils.json_to_sheet([example], { header: HEADER_ORDER });
  styleSheet(ws);
  const wb = XLSX.utils.book_new();
  XLSX.utils.book_append_sheet(wb, ws, "Template");
  XLSX.writeFile(wb, "Template_Master_Payroll_HO.xlsx");
}

export async function parsePayrollHOFile(file) {
  const buf = await file.arrayBuffer();
  const wb = XLSX.read(buf, { type: "array" });
  const ws = wb.Sheets[wb.SheetNames[0]];
  const json = XLSX.utils.sheet_to_json(ws, { defval: "" });

  const rows = [];
  const skipped = [];
  json.forEach((row, i) => {
    const excelRow = i + 2;
    const nik = String(row[PAYROLL_HO_COLS.Nik] ?? row["Nik"] ?? "").trim();
    if (!nik) {
      skipped.push(`Baris ${excelRow}: Nik kosong`);
      return;
    }
    rows.push({
      Nik: nik,
      UpahPokok: toNum(row[PAYROLL_HO_COLS.UpahPokok]),
      Keahlian: toNum(row[PAYROLL_HO_COLS.Keahlian]),
      JkIN: String(row[PAYROLL_HO_COLS.JkIN] ?? "").trim(),
      JkOUT: String(row[PAYROLL_HO_COLS.JkOUT] ?? "").trim(),
      THarian: toNum(row[PAYROLL_HO_COLS.THarian]),
      TLemburMakan: toNum(row[PAYROLL_HO_COLS.TLemburMakan]),
      Harikeenam:
        String(row[PAYROLL_HO_COLS.Harikeenam] ?? "Saturday").trim() ||
        "Saturday",
    });
  });
  return { rows, skipped };
}
